import { gql } from '@src/lib/gql'

export const UPDATE_PROFILE = gql`
  mutation UpdateAdvisorApplicationProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      viewer {
        id
        currentUser {
          id
          email
          firstName
          lastName
          pictureUrl
          shortBio
          location
          locationCity
          locationState
          locationCountryKey
          locationLatitude
          locationLongitude
        }
      }
    }
  }
`
